<!-- eslint-disable prettier/prettier -->
<template>
	<svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" fill="none" class="ki ki-filters"><path fill="currentColor" d="M3 12a9.068 9.068 0 0 0 3 6.75V20a9.985 9.985 0 0 1-4-8 9.985 9.985 0 0 1 3.999-8v1.25A9.07 9.07 0 0 0 3 12Zm18 0a9.069 9.069 0 0 1-3 6.75V20a9.985 9.985 0 0 0 4-8 9.985 9.985 0 0 0-3.999-8v1.25A9.07 9.07 0 0 1 21 12Zm-10.134-2a1 1 0 1 1-1.731-1 1 1 0 0 1 1.731 1Zm1.071-1a2 2 0 0 0-3.874 0H7v1h1.063a2 2 0 0 0 3.874 0H17V9h-5.063Zm1.197 6a1 1 0 1 0 1.731-1 1 1 0 0 0-1.731 1Zm-1.071-1a2 2 0 0 1 3.874 0H17v1h-1.063a2 2 0 0 1-3.874 0H7v-1h5.063Z" clip-rule="evenodd"/></svg>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		width?: number;
		height?: number;
	}>(),
	{
		width: 24,
		height: 24
	}
);
</script>
